module.exports = __webpack_public_path__ + "img/zc-xz.680d3928.png";